import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { ticket } from '@/model/qsadminapi/QsAdminApiModuleModel'
import TicketEditorRoute from '@/routes/tickets/TicketEditor.route'
import { RoleRoute, RouteFunctionParams } from '@/types'
import { Outlet, redirect } from 'react-router-dom'
import { LoaderFunction } from 'react-router-typesafe'

export const ticketMasterViewRouteLoader = (({ params }: RouteFunctionParams<'ticketId'>) => {
  const ticketId = params.ticketId as string
  // Return immediately with just the ticketId — the child loader fetches all ticket data.
  // Permissions are pre-warmed inside the child loader's deferred ticket query.
  return { id: Number(ticketId), ded_Dis: `T.${ticketId.padStart(8, '0')}` } satisfies Partial<ticket>
}) satisfies LoaderFunction

export const TicketMasterViewRoute = {
  path: ':ticketId',
  element: <Outlet></Outlet>,
  errorElement: <RouterErrorHandler />,
  children: [
    {
      index: true,
      loader: () => redirect('details'),
      visible: false,
      allowedRoles: [Roles.Guest],
    } satisfies RoleRoute,
    TicketEditorRoute,
  ],
  loader: ticketMasterViewRouteLoader,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: (match) => ({
      label: match.data.ded_Dis,
    }),
  },
} as RoleRoute<typeof ticketMasterViewRouteLoader>
